/**
 * Code from Vue 2 mixin now in a Vue 3 composable.
 *
 * @author crm4f
 */
import { onMounted, ref } from 'vue'

export const useGeoCommon = () => {
  const geoLatitude = ref(null)
  const geoLongitude = ref(null)
  const geoLocationAvailable = ref(null)
  
  onMounted(() => {
    if (process.env.VUE_APP_MODE === 'hybrid') {
      // In hybrid app, initialise geolocation when device is ready. This stops a double warning in ios.
      document.addEventListener('deviceready', () => {
        console.log('device is ready so initialise geolocation')
        initGeoLocation()
      }, false)
    } else {
      initGeoLocation()
    }
  })

  // Goes back to previous router location
  const initGeoLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          geoLatitude.value = position.coords.latitude
          geoLongitude.value = position.coords.longitude
          geoLocationAvailable.value = true
        },
        function (error) {
          console.log('geolocation error : ' + error.code + ' ' + error.message)
        })
    } else {
      console.log('geolocation not available')
    }
  }
  
  return {
    geoLatitude,
    geoLongitude,
    geoLocationAvailable
  }
}